import { render, staticRenderFns } from "./Rappel.vue?vue&type=template&id=48b7b238&scoped=true"
import script from "./Rappel.vue?vue&type=script&lang=js"
export * from "./Rappel.vue?vue&type=script&lang=js"
import style0 from "./Rappel.vue?vue&type=style&index=0&id=48b7b238&prod&scoped=true&lang=css"
import style1 from "./Rappel.vue?vue&type=style&index=1&id=48b7b238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7b238",
  null
  
)

export default component.exports